import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import Logo from "./Logo";
import { CATEGORIES } from "../data/services";

const LEGAL_LINKS = [
  { to: "/privatlivspolitik", label: "Privatlivspolitik" },
  { to: "/cookiepolitik", label: "Cookiepolitik" },
  { to: "/vilkaar", label: "Vilkår" },
];

export const Footer = () => (
  <footer data-testid="footer" className="bg-brand-950 pb-24 pt-16 text-white sm:pb-16">
    <div className="mx-auto max-w-[1440px] px-6 sm:px-8 lg:px-12">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-4">
          <Logo dark testId="footer-logo" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/85">
            Moderne juridisk rådgivning til både privatpersoner og virksomheder. Vi gør det
            nemt at få overblik — og nemt at komme videre.
          </p>
          <Link
            to="/privatlivspolitik"
            data-testid="footer-gdpr"
            className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/20 px-3.5 py-1.5 text-xs text-white/70 transition-colors hover:border-brand-400 hover:text-brand-400"
          >
            <ShieldCheck className="h-3.5 w-3.5 text-brand-400" />
            Overholder GDPR — dine data er beskyttet
          </Link>
        </div>

        <div className="md:col-span-4" data-testid="footer-services">
          <div className="grid grid-cols-2 gap-x-8 gap-y-10 text-sm">
            {CATEGORIES.map((c) => (
              <div key={c.slug}>
                <Link to={`/ydelser/${c.slug}`} data-testid={`footer-area-${c.slug}`} className="font-semibold text-white transition-colors hover:text-brand-400">
                  {c.title}
                </Link>
                <ul className="mt-5 space-y-2.5">
                  {c.items.map((p) => (
                    <li key={p.slug}>
                      <Link to={`/ydelser/${p.slug}`} data-testid={`footer-service-${p.slug}`} className="text-white/85 transition-colors hover:text-brand-400">
                        {p.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="md:col-span-2">
          <h3 className="text-xs font-semibold tracking-[0.2em] text-white/60">Kontakt</h3>
          <ul className="mt-5 space-y-2.5 text-sm text-white">
            <li><a href="mailto:kontakt@juris.dk" data-testid="footer-email" className="transition-colors hover:text-brand-400">kontakt@juris.dk</a></li>
            <li className="text-white/85">Odeons Kvarter 10, 1</li>
            <li className="text-white/85">5000 Odense C</li>
            <li className="pt-1 text-white/70">CVR 45141233</li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h3 className="text-xs font-semibold tracking-[0.2em] text-white/60">Firma</h3>
          <ul className="mt-5 space-y-2.5 text-sm text-white">
            {LEGAL_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-link-${l.to.slice(1)}`} className="transition-colors hover:text-brand-400">
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <button
                type="button"
                data-testid="footer-cookie-settings"
                onClick={() => window.dispatchEvent(new CustomEvent("juris:cookie-settings"))}
                className="text-left text-white/85 transition-colors hover:text-brand-400"
              >
                Cookieindstillinger
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/15 pt-7 text-xs text-white/85 sm:flex-row sm:items-center">
        <p data-testid="footer-copyright">© 2026 Juris ApS. Alle rettigheder forbeholdes.</p>
        <p className="text-white/70">CVR 45141233</p>
      </div>
    </div>
  </footer>
);

export default Footer;